import React, { Component } from 'react';


class Testimonials extends Component {
  render() {
    if(this.props.data){
      var testimonials = this.props.data.testimonials.map(function(testimonial){
        return <li key={testimonial.user}>
                  <blockquote>
                    <p>{testimonial.text}</p>
                    <cite>{testimonial.user}</cite>
                  </blockquote>
                </li>
      });
    }
    return (
     <section id="testimonials">
      <div className="text-container">
         <div className="row">
            <div className="two columns header-col">
               <h1><span>Inspirational Quotes</span></h1>
            </div>
            <div className="ten columns flex-container">
                <ul className="slides">
                  {testimonials}
                </ul>
            </div> {/* div.flex-container ends */}
         </div> {/* row ends */}
       </div>  {/* text-container ends */}
   </section>
    );
  }
}

export default Testimonials;


// WEBPACK FOOTER //
// ./src/Components/Testimonials.js